import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {FS3ValidationResult} from "../../objects/validationResult";
import {AppComponent} from "../../app.component";
import {ListItem} from "../../objects/listItem";
import {SharedDataService} from "../../services/shared-data.service";
import {FS3Notification} from "../../objects/notification";
import { v4 } from 'uuid';

@Component({
  selector: 'app-rename-form',
  templateUrl: './rename-form.component.html',
  styleUrls: ['./rename-form.component.css']
})
export class RenameFormComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() state: string;
  @Input() payload: object;
  @Output() close = new EventEmitter<void>();
  @Output() success = new EventEmitter<void>();

  private formValidationMessages = {
    required: 'Value is required.',
  };
  public validationResult: FS3ValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public textInput: FormControl = new FormControl('', [Validators.required, this.formValidator()]);
  private isDblClick = false;

  constructor(private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.componentForm.addControl('textInput', this.textInput);
    switch (this.state) {
      case 'articles-category-rename':
        (this.payload['categoryIdx'] === -1) ?
          this.textInput.setValue('') :
          this.textInput.setValue(this.payload['listItems'][this.payload['categoryIdx']]['group_name']);
        break;
      default:
        this.textInput.setValue('change me');
    }
  }

  public handleSubmit(event: Event | void = null): boolean {
    if (event) {
      event.stopPropagation();
    }
    if (this.isDblClick) {
      return false;
    }

    if (!this.textInput.valid) {
      const errorKey = Object.keys(this.textInput.errors)[0]; // get error key from input errors
      this.validationResult = {
        isValid: false,
        message: this.textInput.errors[errorKey] // get error string by errorKey
      };
      return false;
    }

    this.isDblClick = true;

    switch (this.state) {
      case 'articles-category-rename':
        this.saveArticlesData();
        break;
    }

    return false
  }

  public onNoClick(): void {
    //this.dialogRef.close();
    this.close.emit()
  }

  private formValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      const value = control.value.toString().replace(/ /g, '');
      if (!value) {
        return {required: this.formValidationMessages.required}
      }

      // if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
      //   return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      // }
      //
      // if (Math.abs(control.value) > 9999) {
      //   return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      // }

      return null;
    };
  }

  saveArticlesData() {
    if(this.payload['categoryIdx'] === -1) {
      let category = {
        sorder: 0,
        group_name: this.textInput.value,
        group_key: v4(),
        group_image_src: '',
        articles: [],
      };
      this.payload['listItems'].unshift(category);
    }
    let newArticlesPositions = this.payload['listItems'].map( (category, index) => {
      let ret = {};
      ret['sorder'] = index;
      ret['group_name'] = (this.payload['categoryIdx'] === index) ? this.textInput.value : category['group_name'];
      ret['group_key'] = category['group_key'];
      ret['group_image_src'] = category['group_image_src'];
      ret['articles_uuids'] = category['articles'].map( (article) => {
        return article['itemFullData']['uuid'];
      });
      return ret;
    })
    this.application.apiService
      .updateArticlesGroups(newArticlesPositions,this.payload['folderUUID'])
      .subscribe(
        data => {
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = 'Updated';
          this.sharedDataService.pushNotification(notification);
          if(this.payload['categoryIdx'] !== -1) {
            this.payload['listItems'][this.payload['categoryIdx']]['group_name'] = this.textInput.value;
          }
          this.success.emit()
        },
        error => {
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          } else {
            //maybe close dialog
          }
        }
      )
  }

}
